import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

const MaltaFAQ = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const defaultFAQs = [
    {
      question: "How long does migration take?",
      answer: "Our migration process typically takes 2-3 business days. We'll work with your team to ensure a smooth transition with minimal disruption to your operations."
    },
    {
      question: "Will my data be secure during transfer?",
      answer: "Absolutely. We use enterprise-grade encryption and follow strict data protection protocols. Your data is never stored on unsecured servers during the migration process."
    },
    {
      question: "What's included in the €450?",
      answer: "The €450 includes complete data migration, team training sessions, system setup, and your first month of service. No hidden fees or additional costs."
    },
    {
      question: "Do I need technical knowledge?",
      answer: "Not at all. Our team handles the entire migration process. We'll train your staff on how to use Buddy, and our support team is always available to help."
    },
    {
      question: "What happens after January if I don't switch?",
      answer: "You can continue using your current system, but you'll miss out on Buddy's time-saving features and automated compliance updates. The €450 migration offer is only available until December 15th."
    },
    {
      question: "Can I try before committing?",
      answer: "Yes! We offer a free demo account so you can explore Buddy's features. The €450 migration offer includes this trial period plus full migration and training."
    }
  ];

  const faqData = faqs || defaultFAQs;

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Everything you need to know about switching to Buddy
          </p>
        </div>

        <div className="mt-12 space-y-4">
          {faqData.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow">
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-inset"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-lg font-medium text-gray-900">
                  {faq.question}
                </span>
                <ChevronDownIcon
                  className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600">
            Still have questions?{' '}
            <a
              href="https://support.buddy.hr/hc/en-mt/requests/new?ticket_form_id=13159221572114"
              className="font-medium text-orange-600 hover:text-orange-500"
            >
              Contact our support team
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaltaFAQ;
